
<template>
	<div class="contentbox">
    <div class="wbdp-feedback">
      <div class="top-search">
				<el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline select-nobg">
          <el-form-item label="用户ID" prop="userId">
            <el-input v-model="formInline.userId" placeholder="请输入用户ID" clearable @keyup.enter.native="search"
              @clear="search" style="width: 180px;"></el-input>
          </el-form-item>
          <!-- <el-form-item label="日期：">
						<el-date-picker
							v-model="dataTime"
							class="pickerData"
							format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
							unlink-panels
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期" style="margin-right: 10px; width: 400px" clearable @change="search">
						</el-date-picker>
					</el-form-item> -->
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>
			</div>
      <div class="tableTh" v-height>
				<el-table :data="tableData.result" border stripe style="width: 100%" height="100%" class="tableStyle" v-loading="loading">
          <el-table-column prop="" label="序号" width="60">
						<template slot-scope="scope">
							<span>{{(tableData.pageNo - 1)* tableData.pageSize + scope.$index + 1}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="userId" label="用户ID">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.userId}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="nickName" label="用户昵称">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.nickName}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="content" label="用户反馈">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.content}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="userContactInfo" label="用户信息" >
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.userContactInfo}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="addTimeStr" label="时间" >
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{scope.row.addTimeStr}}</p>
							</div>
						</template>
					</el-table-column>
					<!-- <el-table-column label="操作" width="100">
						<template slot-scope="scope" class="ddd">
							<el-button type="defult" icon="el-icon-warning-outline" size="mini" @click="handleDetails(scope.row)">详情</el-button>
						</template>
					</el-table-column> -->
				</el-table>
				<div class="foot-table" style="text-align:center;">
					<el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :page-sizes="[20, 50, 100, 200, 500]"
            :page-size="tableData.pageSize"
            background
            :current-page="currentPage"
            layout="sizes, prev, pager, next, jumper, ->, total"
            :total="tableData.totalNum">
					</el-pagination>
				</div>
			</div> 

    </div>
  </div>
</template>
<script>
export default {
	data() {
		return {
      formInline:{
        userId:"",
      },
      // dataTime:[],
      currentPage:1,
      loading:false,
      tableData: {
        pageSize: 20,
        pageNo: 1,
        totalPage: 1,
        totalNum: 0,
        result: []
      },
		}
	},
	computed: {},
	watch: {},
	mounted: function () {
		this.getTableData()
	},
	methods: {
     // 查询
    search() {
      this.currentPage = 1
      this.loading = true
      this.getTableData()
    },
    // 重置
    resetQuery() {
      this.loading = true
      this.$refs['formInline'].resetFields()
      this.dataTime = []
      this.getTableData()
    },
    // pageSize切换
    handleSizeChange (val) {
      this.tableData.pageSize  = val
      this.currentPage = 1
      this.loading = true
      this.getTableData()
    },
    handleCurrentChange(value) {
      this.currentPage = value
      this.loading = true
      this.getTableData()
    },

    // 获取列表数据
    getTableData(){
      let json2 = {
        pageNo: this.currentPage,
        pageSize: this.tableData.pageSize
      };
      // this.formInline.statStartDate = this.dataTime ? this.dataTime[0] : ''
      // this.formInline.statEndDate = this.dataTime ? this.dataTime[1] : ''
      let json1 = this.formInline;
      let paramJson = { ...json1, ...json2, appId: localStorage.getItem('appId')};
      this.axios({
        method:'get',
        url:'/v1/wbdp/feedback/list',
        params:paramJson
      }).then((response)=>{
       if (response.data.head.flag === 0) {
          this.tableData = response.data.content
          this.loading = false
        } else {
          this.$message.error(response.data.head.desc)
        }
      })
    }
	}
}
</script>
<style lang="scss">

</style>
